import { render, staticRenderFns } from "./MbModal.vue?vue&type=template&id=5ddcc078&scoped=true&"
import script from "./MbModal.vue?vue&type=script&lang=js&"
export * from "./MbModal.vue?vue&type=script&lang=js&"
import style0 from "./MbModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MbModal.vue?vue&type=style&index=1&id=5ddcc078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddcc078",
  null
  
)

export default component.exports